module.exports = "<div class=\"project-public-feed\">\n  <pre><code>{{response|json}}</code></pre>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/detail/project-detail-api/project-detail-api.component.html
// module id = ./src/app/projects/detail/project-detail-api/project-detail-api.component.html
// module chunks = main